import React from 'react'
import { useTranslation } from 'react-i18next'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { podpowiedzPola, zakresPola } from '../../config/typoweParametry'

/**
 * Uzupełnienie brakujących parametrów z karty katalogowej.
 *
 * Wspólny dla panelu w asystencie i dla okna schematu na kolejnych krokach —
 * ten sam formularz w dwóch miejscach rozjechałby się przy pierwszej poprawce.
 *
 * `braki` to lista prosto z API: `{ strona, pole, etykieta_pl }`. Nazwy pól są
 * po stronie backendu, żeby dopisanie parametru nie wymagało zmiany frontu.
 * Backend tłumaczy je sam (`komunikat` i `etykieta_pl` przychodzą w języku kraju).
 */

/**
 * Podpowiedź z `config/typoweParametry` w języku kraju. Config składa ją po polsku
 * („zwykle ok. 49 V”, „zwykle w nazwie modelu”), więc podmieniamy same słowa.
 */
const podpowiedzWJezyku = (t, tekst) => {
  if (!tekst) return tekst
  if (tekst === 'zwykle w nazwie modelu') return t('formularz.w_nazwie_modelu')
  const m = /^zwykle ok\. (.+)$/.exec(tekst)
  return m ? t('formularz.zwykle_ok', { wartosc: m[1] }) : tekst
}

const FormularzBrakow = ({ braki, komunikat, wartosci, onZmiana, onLicz, ladowanie }) => {
  const { t } = useTranslation('elektryka')
  return (
    <div className="space-y-3">
      {komunikat && (
        <div className="flex items-start gap-2.5 rounded-lg border border-amber-100 bg-amber-50
                        px-3 py-2.5 text-sm leading-6 text-amber-800">
          <InformationCircleIcon className="w-[18px] h-[18px] flex-shrink-0 mt-1" />
          <p className="min-w-0">{komunikat}</p>
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-3">
        {braki.map((b) => {
          const klucz = `${b.strona}.${b.pole}`
          return (
            <label key={klucz} className="block">
              <span className="block text-xs font-medium text-gray-600 mb-1">
                {b.etykieta_pl}
                <span className="text-gray-400"> · {b.strona === 'panel' ? t('formularz.modul') : t('formularz.falownik')}</span>
              </span>
              {/* PODPOWIEDŹ, nie wartość domyślna — patrz config/typoweParametry.
                  Pole zostaje puste i nadal wymaga wpisania liczby; podstawienie
                  z automatu dałoby projekt policzony dla wymyślonego produktu,
                  wyglądający tak samo jak policzony dla prawdziwego. */}
              <input
                type="number" step="any" inputMode="decimal"
                value={wartosci[klucz] ?? ''}
                placeholder={podpowiedzWJezyku(t, podpowiedzPola(b.strona, b.pole)) || ''}
                onChange={(e) => onZmiana(klucz, e.target.value)}
                className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm
                           placeholder:text-gray-300
                           focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {zakresPola(b.strona, b.pole) && (
                <span className="block text-[10px] text-gray-400 mt-1">
                  {t('formularz.typowy_zakres', { zakres: zakresPola(b.strona, b.pole) })}
                </span>
              )}
            </label>
          )
        })}
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <button type="button" onClick={onLicz} disabled={ladowanie}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold
                           hover:bg-blue-500 disabled:bg-gray-300 transition-colors">
          {ladowanie ? t('formularz.licze') : t('formularz.policz')}
        </button>
        <span className="text-xs text-gray-400">
          {t('formularz.gdzie_szukac')}
        </span>
      </div>
    </div>
  )
}

export default FormularzBrakow
